var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMetamaskFox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70.2,
    height: 65.094,
    viewBox: "0 0 70.2 65.094",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MetaMask_Fox",
    transform: "translate(-31.7 -35.4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1513",
    "data-name": "Path 1513",
    d: "M201.914,35.5,174.6,55.786l5.051-11.969Z",
    transform: "translate(-103.6)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1514",
    "data-name": "Path 1514",
    d: "M44.4,35.5,71.494,55.978l-4.8-12.161Z",
    transform: "translate(-9.141)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1515",
    "data-name": "Path 1515",
    d: "M219.075,206.8,211.8,217.945l15.565,4.282,4.475-15.18Z",
    transform: "translate(-130.588 -124.276)",
    fill: "currentColor",
    opacity: 0.6,
    stroke: "#5962a1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1516",
    "data-name": "Path 1516",
    d: "M33.9,207.047l4.447,15.18,15.565-4.282L46.637,206.8Z",
    transform: "translate(-1.524 -124.276)",
    fill: "currentColor",
    opacity: 0.6,
    stroke: "#5962a1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1517",
    "data-name": "Path 1517",
    d: "M92.137,113.461,87.8,120.022l15.455.686-.549-16.608Z",
    transform: "translate(-40.627 -49.769)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1518",
    "data-name": "Path 1518",
    d: "M185.663,112.953,174.957,103.4l-.357,16.8,15.427-.686Z",
    transform: "translate(-103.6 -49.261)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1519",
    "data-name": "Path 1519",
    d: "M106.8,218.888l9.278-4.529-8.016-6.259Z",
    transform: "translate(-54.412 -125.22)",
    fill: "currentColor",
    opacity: 0.6,
    stroke: "#5962a1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1520",
    "data-name": "Path 1520",
    d: "M177.9,214.359l9.306,4.529-1.29-10.788Z",
    transform: "translate(-105.994 -125.22)",
    fill: "currentColor",
    opacity: 0.6,
    stroke: "#5962a1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1521",
    "data-name": "Path 1521",
    d: "M187.206,235.429,177.9,230.9l.741,6.067-.082,2.553Z",
    transform: "translate(-105.994 -141.761)",
    fill: "#ebecff",
    stroke: "#ebecff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1522",
    "data-name": "Path 1522",
    d: "M106.8,235.429l8.647,4.09-.055-2.553.686-6.067Z",
    transform: "translate(-54.412 -141.761)",
    fill: "#ebecff",
    stroke: "#ebecff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1523",
    "data-name": "Path 1523",
    d: "M118.341,180.876,110.6,178.6l5.463-2.5Z",
    transform: "translate(-57.169 -102.004)",
    fill: "#1e2033",
    stroke: "#1e2033",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1524",
    "data-name": "Path 1524",
    d: "M179.7,180.876l2.278-4.776,5.49,2.5Z",
    transform: "translate(-107.3 -102.004)",
    fill: "#1e2033",
    stroke: "#1e2033",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1525",
    "data-name": "Path 1525",
    d: "M87.575,217.945,88.892,206.8l-8.592.247Z",
    transform: "translate(-35.186 -124.276)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1526",
    "data-name": "Path 1526",
    d: "M207,206.8l1.318,11.145,7.275-10.9Z",
    transform: "translate(-127.106 -124.276)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1527",
    "data-name": "Path 1527",
    d: "M190.027,162.1l-15.427.686,1.427,7.933,2.278-4.776,5.49,2.5Z",
    transform: "translate(-103.6 -91.847)",
    fill: "currentColor",
    opacity: 0.6,
    stroke: "#5962a1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1528",
    "data-name": "Path 1528",
    d: "M94.059,168.441l5.49-2.5,2.251,4.776,1.455-7.933L87.8,162.1Z",
    transform: "translate(-40.627 -91.847)",
    fill: "currentColor",
    opacity: 0.6,
    stroke: "#5962a1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1529",
    "data-name": "Path 1529",
    d: "M87.8,162.1l6.478,12.627-.22-6.286Z",
    transform: "translate(-40.627 -91.847)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1530",
    "data-name": "Path 1530",
    d: "M207.375,168.441l-.275,6.286,6.506-12.627Z",
    transform: "translate(-127.178 -91.847)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1531",
    "data-name": "Path 1531",
    d: "M140.255,164.6l-1.455,7.933,1.812,9.361.412-12.326Z",
    transform: "translate(-77.627 -93.661)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1532",
    "data-name": "Path 1532",
    d: "M172.641,164.6l-.741,4.941.329,12.353,1.839-9.361Z",
    transform: "translate(-101.641 -93.661)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1533",
    "data-name": "Path 1533",
    d: "M174.939,187.478l-1.839,9.361,1.318.906,8.016-6.259.275-6.286Z",
    transform: "translate(-102.512 -108.606)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1534",
    "data-name": "Path 1534",
    d: "M110.6,185.2l.22,6.286,8.016,6.259,1.318-.906-1.812-9.361Z",
    transform: "translate(-57.169 -108.606)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1535",
    "data-name": "Path 1535",
    d: "M126.976,251.49l.082-2.553-.686-.6H116.024l-.631.6.055,2.553L106.8,247.4l3.02,2.471,6.122,4.255h10.514l6.149-4.255,3.02-2.471Z",
    transform: "translate(-54.412 -153.731)",
    fill: "#c8c9da",
    stroke: "#c8c9da",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1536",
    "data-name": "Path 1536",
    d: "M149.025,228.506l-1.318-.906h-7.6l-1.318.906-.686,6.067.631-.6H149.08l.686.6Z",
    transform: "translate(-77.12 -139.367)",
    fill: "currentColor",
    stroke: "currentColor",
    opacity: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1537",
    "data-name": "Path 1537",
    d: "M205.461,57.1l2.333-11.2-3.486-10.4L177.9,55.1l10.157,8.592,14.357,4.2,3.184-3.706-1.373-.988,2.2-2-1.7-1.318,2.2-1.675Z",
    transform: "translate(-105.994)",
    fill: "currentColor",
    stroke: "currentColor",
    opacity: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1538",
    "data-name": "Path 1538",
    d: "M31.8,45.9l2.333,11.2-1.482,1.1,2.2,1.675-1.675,1.318,2.2,2L34,64.186l3.157,3.706,14.357-4.2L61.667,55.1,35.259,35.5Z",
    fill: "currentColor",
    stroke: "currentColor",
    opacity: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1539",
    "data-name": "Path 1539",
    d: "M223.6,142.4l-14.357-4.2,4.365,6.561L207.1,157.388l8.565-.11h12.765Z",
    transform: "translate(-127.178 -74.508)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1540",
    "data-name": "Path 1540",
    d: "M53.033,138.2l-14.357,4.2L33.9,157.278H46.637l8.537.11L48.7,144.761Z",
    transform: "translate(-1.524 -74.508)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1541",
    "data-name": "Path 1541",
    d: "M139.051,92.922l.906-15.839L144.129,65.8H125.6l4.118,11.282.961,15.839.329,5,.027,12.3h7.6l.055-12.3Z",
    transform: "translate(-68.051 -21.982)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetamaskFox);
export default __webpack_public_path__ + "static/media/metamask-fox.5b2c2026.svg";
export { ForwardRef as ReactComponent };